module.exports = __webpack_public_path__ + "static/media/regulamento_Mais apoio_2025.fc4e0e66.pdf";